// You can find the id here
// https://portal.sourcepoint.com/consent_v2/vendor_lists/edit?id=6233296a293cdf6b366969ee&non_iab=false
// Vendor: Google Analytics
const GOOGLE_ANALYTICS_ID: string = '5e542b3a4cd8884eb41b5a72';
export default (grants: TSourcePointGrants): boolean => {
  return grants[GOOGLE_ANALYTICS_ID]?.vendorGrant;
};
